export default "__VITE_ASSET__308d74ce__"